import * as types from './types';

export const getModuls = () => ({
    type: types.FETCH_MODULES
})

export const getModulsSuccess = ({ items }) => ({
    type: types.FETCH_MODULES_SUCCESS,
    payload: items
})